import { render, staticRenderFns } from "./PlannerTableColumn.vue?vue&type=template&id=0cba84a0&scoped=true"
import script from "./PlannerTableColumn.vue?vue&type=script&lang=js"
export * from "./PlannerTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cba84a0",
  null
  
)

export default component.exports